export default (value) => {
  if (value) {
    return value.toUpperCase();
  }
};
